'use client';

import { TextField, MenuItem } from '@mui/material';

import { SelectInputProps, SelectOption } from '../types';

export function SelectInput<T extends string | number>(
  props: SelectInputProps<T>,
) {
  return (
    <TextField
      fullWidth
      select
      name={props.name}
      label={props.label}
      value={props.value}
      onChange={(e) => props.onChange(e.target.value as T)}
      error={!!props.error}
      helperText={props.error}
      disabled={props.readOnly}
      size={props.size}
      slotProps={{
        input: {
          name: props.name,
        },
      }}
    >
      {props.options.map((opt: SelectOption<T>) => (
        <MenuItem key={String(opt.value)} value={opt.value}>
          {opt.label}
        </MenuItem>
      ))}
    </TextField>
  );
}
